import React, { forwardRef, useContext } from "react";

import { LoginContext } from "src/core/loginContext";

/**
 * Hides the wrapped component when the current
 * user does not have the ADMIN role.
 */
export const withAdminGuard = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const Guarded = forwardRef<unknown, P>((props, ref) => {
    const { isAdmin } = useContext(LoginContext);

    if (!isAdmin) {
      return null;
    }

    return <WrappedComponent {...props} ref={ref} />;
  });

  Guarded.displayName = `withAdminGuard(${
    WrappedComponent.displayName ?? WrappedComponent.name ?? "Component"
  })`;

  return Guarded;
};
